import { 
  uploadBloodPressureDeviceCsv, 
  uploadWeightBloodPressureDeviceCsv,
  uploadForeDeviceCsv,
  uploadFreeStyleLibreLinkDeviceCsv,
  uploadFreeStyleLibreLinkDeviceCsv2
} from '@/api/deviceApi';

export const devices = [
  // {
  //   id: 1,
  //   name: 'BLOOD_PRESSURE_DEVICE',
  //   // other information about a device,
  //   upload: uploadBloodPressureDeviceCsv
  // },
  {
    id: 1,
    name: 'Blipcare Device',
    // other information about a device,
    upload: uploadWeightBloodPressureDeviceCsv
  },
  {
    id: 2,
    name: 'Fora Device',
    upload: uploadForeDeviceCsv
  },
  // {
  //   id: 4,
  //   name: 'Free Style Libre Link Device',
  //   upload: uploadFreeStyleLibreLinkDeviceCsv
  // },
  {
    id: 3,
    name: 'Free Style Libre Link Device',
    upload: uploadFreeStyleLibreLinkDeviceCsv2
  }
]
